// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"36":"6401e254","420":"5f334959"}[chunkId] + ".css";
};